import { render } from "./certified_partner_serialnos_form.vue?vue&type=template&id=7f9535a6"
import script from "./certified_partner_serialnos_form.vue?vue&type=script&lang=js"
export * from "./certified_partner_serialnos_form.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__